import { EnhancedModel, Model } from '../__generated/configurator-builder.js'
import { implementCustomExpressions } from '../__generated/implementation.js'

export const baseFourLegSeparateExpressions = implementCustomExpressions({
  BaseFourLegSeparate: {
    $width: s => s.$table.$top.$width + s.$beveledEdgeConsideration,
    $length: s => s.$table.$top.$length + s.$beveledEdgeConsideration,

    $legWidth: s => s.$baseDataMap[s.type]?.sizing.width,

    $dropInLeafAdditionalOffset: s =>
      s.$table.$top.$leafCenterVisible ? (s.$table.$top.$leafLength * s.$table.$top.leafAmount) / 2 : 0,
    $beveledEdgeConsideration: s =>
      s.$table.$top.edgeStyle === Model.EdgeStyles.Beveled && !EnhancedModel.$TraditionalFlushBase.is(s)
        ? -(s.$table.$top.$bevelThickness * 2)
        : 0,

    $offsetXTopLeft: s => s.$width / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset,
    $offsetZTopLeft: s =>
      -1 *
      (s.$length / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset + s.$dropInLeafAdditionalOffset),

    $offsetXBottomLeft: s => -1 * (s.$width / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset),
    $offsetZBottomLeft: s =>
      -1 *
      (s.$length / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset + s.$dropInLeafAdditionalOffset),

    $offsetXTopRight: s => s.$width / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset,
    $offsetZTopRight: s =>
      s.$length / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset + s.$dropInLeafAdditionalOffset,

    $offsetXBottomRight: s => -1 * (s.$width / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset),
    $offsetZBottomRight: s =>
      s.$length / 2 - s.$legWidth / 2 - s.$baseDataMap[s.type].positioning.legInset + s.$dropInLeafAdditionalOffset,

    $heightScaleZero: s => {
      const sizing = s.$baseDataMap[s.type]?.sizing
      return 'height' in sizing ? sizing.height.scaleZero : 0
    },
    $heightScaleOne: s => {
      const sizing = s.$baseDataMap[s.type]?.sizing
      return 'height' in sizing ? sizing.height.scaleOne : 0
    },
    $separateLegRepeatX: () => 0.5, // looks best (actual ratio looks deformed)
    $separateLegRepeatY: s => s.$height / s.$table.$woodTextureSize,
  },
})
